export default __webpack_public_path__ + "static/media/caret-up.5095e43a.svg";